import React, { useState, useContext } from 'react';
import Header from '../../layout/header/Header';
import Footer from '../../layout/footer/Footer';
import { Container, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../store/GlobalContext';
import { loginCustomer } from '../../features/auth/api/authApi';
import { useI18n } from '../../i18n/I18nContext';
import '../auth.css';

const Login = () => {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const from = location?.state?.from?.pathname || "/";
  const { login } = useContext(GlobalContext);
  const { t } = useI18n();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setError('');
    event.preventDefault();

    if (!usernameOrEmail || !password) {
      setError(t('login_all_fields_required'));
      return;
    }

    try {
      const result = await loginCustomer({ usernameOrEmail, password });
      if (result.accessToken) {
        login(result.accessToken, result.user, result.refreshToken);
        navigate(from, { replace: true });
      } else {
        setError(t('login_failed'));
      }
    } catch (error: any) {
      const status = error?.response?.status;
      const backendMessage = error?.response?.data?.message;

      if (status === 401 || status === 403) {
        setError('Incorrect username/email or password.');
      } else if (backendMessage && typeof backendMessage === 'string') {
        setError(backendMessage);
      } else {
        setError(t('login_failed'));
      }
    }
  };

  return (
    <>
      <Header />
      <section className="arkab-auth-hero">
        <Container>
          <h1>{t('login_title')}</h1>
          <p>Access your account to track orders, favourites, and checkout faster.</p>
        </Container>
      </section>
      <Container className="my-5 arkab-auth-shell">
        <Row className="justify-content-center">
          <Col md={8} lg={7}>
            <div className="arkab-auth-card">
            <h2 className="text-center mb-4">{t('login_title')}</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicUsernameOrEmail">
                <Form.Label>{t('login_username_email')}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('login_username_email')}
                  value={usernameOrEmail}
                  onChange={(e) => setUsernameOrEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>{t('login_password')}</Form.Label>
                <Form.Control
                  type="password"
                  placeholder={t('login_password')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <div className="mb-3 text-end">
                <Link to="/forgot-password">{t('login_forgot_password')}</Link>
              </div>

              <div className="d-grid mb-3">
                <Button variant="dark" type="submit" className="arkab-auth-primary-btn">
                  {t('login_sign_in')}
                </Button>
              </div>

              <div className="text-center arkab-auth-inline-links">
                <Button variant="link" onClick={() => navigate('/register')}>
                  {t('login_create_account')}
                </Button>
                <Button variant="link" onClick={() => navigate('/admin/login')}>
                  {t('login_admin_entry')}
                </Button>
              </div>
            </Form>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default Login;